<script>
import {contractType} from '@/assets/data/optionData.js';
import moment from 'moment';
import DesignAmountInput from '@/components/design-system/design-amount-input.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignFileUpload from '@/components/design-system/design-file-upload.vue';
import DesignDatepicker from '@/components/design-system/design-datepicker.vue';
import {
    salaryAmountTypeOptions,
    taxCodeOptions,
    peraTypeOptions,
} from '@/pages/employees/employees/popups/salaryOptionData.js';

export default {
    props: {
        salaryInfo: Object,
        employeeData: Object,
        modelValue: Boolean,
    },
    components: {
        DesignAmountInput,
        DesignInput,
        DesignDropdownSelect,
        DesignFileUpload,
        DesignDatepicker,
    },
    data() {
        return {
            joinDate: '',
            employmentType: '',
            salaryData: {
                salaryAmountType: '',
                salaryAmount: null,
                errorMessage: null,
                taxCode: '',
                taxFilePath: '',
                taxFileName: '',
                peraYear: '',
                peraType: '',
                peraAmount: '',
                peraCertificateFilePath: '',
                peraCertificateFileName: '',
                otherDetails: '',
                effectiveDate: null,
                minEffectiveDate: null,
                pic: sessionStorage.getItem("pic"),
            },
            taxFileName: '',
            peraCertificateFileName: '',
            salaryAmountTypeOptions,
            taxCodeOptions,
            peraTypeOptions,
            minDateForEffectiveDate: null,
            minDateDisplayString: null,
        }; //return
    }, //data
    watch: {
        modelValue(newVal) {
            if (!newVal) {
                return;
            }
            const self = this;

            // 이 팝업이 실행될 때 마다 실행되어야 하는 작업
            // 마지막 payroll 다음날 부터 설정 가능하며 payroll이 없다면 join date 부터 설정 가능
            const url = self
                .$api('uri', 'get-employee-salary-last-payroll-cut-off')
                .replace('{employeeSeq}', self.employeeData.employeeSeq);
            self.$axios
                .get(url)
                .then((res) => {
                    let minDate;
                    if (res.data.data != null && res.data.data.cutOffToDatetime != null) {
                        minDate = moment(res.data.data.cutOffToDatetime).add(1, 'days').toDate();
                    } else {
                        minDate = moment(parseInt(self.employeeData.joinDate), 'YYYYMMDD').toDate();
                    }
                    self.minDateForEffectiveDate = minDate;
                    self.minDateDisplayString = moment(minDate).format('MM/DD/YYYY');
                    self.salaryData.minEffectiveDate = moment(minDate).format('YYYYMMDD');
                })
                .catch((err) => {
                    console.log(err);
                });

            if (self.salaryInfo) {
                let effectiveDate = moment(self.salaryInfo.effectiveDate).format('YYYYMMDD');
                self.salaryData = { ...self.salaryInfo, effectiveDate };
                self.salaryData.pic = sessionStorage.getItem("pic");
            }
        },
        'salaryInfo.errorMessage'(newVal) {
            this.salaryData.errorMessage = newVal;
        },
    },
    mounted() {
        const self = this;
        const employeeData = self.employeeData;

        if (employeeData) {
            self.joinDate = employeeData.joinDate;
            const employmentType = employeeData.employmentType;

            for (const contract of contractType) {
                if (contract.value == employmentType) {
                    self.employmentType = contract.text;
                }
            }
        }
        self.salaryData.pic = sessionStorage.getItem("pic");
    },
    methods: {
        moment: moment,
        parseInt: parseInt,
        getSalaryData() {
            const self = this;
            return self.salaryData;
        },
        handleFileChange(file, target) {
            const self = this;

            if (file == null) {
                return;
            }

            const filePath = file;
            const fileName = file.name;

            self.submitFileUpload(target, filePath, fileName);
        },
        submitFileUpload(target, filePath, fileName) {
            const self = this;
            const url = self.$api('uri', 'post-file-direct-upload');

            let form = new FormData();
            form.append(`uploadFile1`, filePath);
            form.append(`uploadFileName`, fileName);

            if (filePath === null) {
                return;
            }

            self.$axios
                .post(url, form, {headers: {'Content-Type': 'multipart/form-data;'}})
                .then((res) => {
                    if (target == 'TAX_FILE_PATH') {
                        self.salaryData.taxFilePath = res.data.data.uploadFile1;
                        self.salaryData.taxFileName = fileName;
                    } else if (target == 'PERA_CERTIFICATE_FILE_PATH') {
                        self.salaryData.peraCertificateFilePath = res.data.data.uploadFile1;
                        self.salaryData.peraCertificateFileName = fileName;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    alert(' submit File Upload fail ');
                });
        },
        deleteFile(target) {
            const self = this;

            let filePath = null;
            let doNotDelete = false;

            if (target == 'TAX_FILE_PATH') {
                filePath = self.salaryData.taxFilePath;
                doNotDelete = self.salaryInfo && self.salaryInfo.taxFilePath == filePath; // 이전에 가지고 있는거랑 같으면 삭제 안함
            } else if (target == 'PERA_CERTIFICATE_FILE_PATH') {
                filePath = self.salaryData.peraCertificateFilePath;
                doNotDelete = self.salaryInfo && self.salaryInfo.peraCertificateFilePath == filePath;
            }

            if (!filePath || doNotDelete) {
                self.deleteFilePathAndName(target);
                return;
            }

            self.$axios
                .delete(filePath)
                .then((res) => {
                    self.deleteFilePathAndName(target);
                    console.log(res);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        deleteFilePathAndName(target) {
            const self = this;

            if (target == 'TAX_FILE_PATH') {
                self.salaryData.taxFilePath = '';
                self.salaryData.taxFileName = '';
            } else if (target == 'PERA_CERTIFICATE_FILE_PATH') {
                self.salaryData.peraCertificateFilePath = '';
                self.salaryData.peraCertificateFileName = '';
            }
        },
        toDatePickerValue(value) {
            if (!value) {
                return null;
            }
            if (value instanceof Date) {
                return value;
            }
            return moment(String(value), 'YYYYMMDD').toDate();
        },
    },
};
</script>

<template>
    <div class="p-5 pt-0">
        <!--Join Date-->
        <div class="flex justify-between items-center gap-2 mt-6 w-96">
            <div class="w-32 c_label">
                Join Date
            </div>
            <div class="flex-1">
                {{ moment(parseInt(joinDate), 'YYYYMMDD').format('MM/DD/YYYY') }}
            </div>
        </div>

        <!--Employment Type-->
        <div class="flex justify-between items-center gap-2 mt-6">
            <div class="w-32 c_label">
                Employment Type
            </div>
            <div class="flex-1">
                {{ employmentType }}
            </div>
        </div>

        <!--Amount*-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label mandatory">Amount</p>
            </div>

            <div class="flex-1">
                <DesignDropdownSelect
                    v-model="salaryData.salaryAmountType"
                    placeholder="Salary Type"
                    class="flex-1"
                    width="w-full"
                    :options="salaryAmountTypeOptions"
                    :useDefaultMsg="true" />
                <DesignAmountInput
                    v-model="salaryData.salaryAmount"
                    :intPartLimit="9"
                    placeholder="Enter the contract amount"
                    :error="salaryData.errorMessage"
                    class="flex-1 mt-1" />
            </div>
        </div>

        <!--Tax Code*-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label mandatory">Tax Code</p>
            </div>
            <div class="flex-1">
                <DesignDropdownSelect
                    v-model="salaryData.taxCode"
                    placeholder="Tax Code"
                    :options="taxCodeOptions"
                    :useDefaultMsg="true"
                    width="w-full"
                    class="flex-1"/>

                <DesignFileUpload
                    :modelValue="salaryData.taxFilePath"
                    :fileName="salaryData.taxFileName"
                    placeholder="Select File"
                    size="LG"
                    accept=".jpg,.jpeg,.png,.pdf"
                    class="mt-2"
                    @change="handleFileChange($event, 'TAX_FILE_PATH')"
                    @delete="deleteFile('TAX_FILE_PATH')"
                />
                <div class="mt-2 flex items-start gap-2">
                    <!-- <img src="@/assets/img/tab-job-info-2.svg" alt="tab-job-info-2"/> -->
                    <p class="c_input_message">
                        Only JPEG,PNG and PDF files with Max size of 5MB
                    </p>
                </div>
            </div>
        </div>

        <!--PERA Info-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label">PERA Info</p>
            </div>
            <div class="flex-1">
                <DesignInput
                    v-model="salaryData.peraYear"
                    placeholder="Input Year"
                    inputtype="number"
                />
                <DesignDropdownSelect
                    v-model="salaryData.peraType"
                    placeholder="PERA Type"
                    class="flex-1 mt-1"
                    width="w-full"
                    :options="peraTypeOptions"
                    :useDefaultMsg="true"/>
                <DesignAmountInput
                    v-model="salaryData.peraAmount"
                    placeholder="Enter the PERA amount"
                    class="flex-1 mt-1"/>
            </div>
        </div>

        <!--PERA Certificate-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label">PERA Certificate</p>
            </div>
            <div class="flex-1">
                <DesignFileUpload
                    :modelValue="salaryData.peraCertificateFilePath"
                    :fileName="salaryData.peraCertificateFileName"
                    placeholder="Select File"
                    size="LG"
                    accept=".jpg,.jpeg,.png,.pdf"
                    @change="handleFileChange($event, 'PERA_CERTIFICATE_FILE_PATH')"
                    @delete="deleteFile('PERA_CERTIFICATE_FILE_PATH')"
                />
                <div class="mt-2 px-2 flex items-start gap-2">
                    <p class="c_input_message">
                        Only JPEG,PNG and PDF files with Max size of 5MB
                    </p>
                </div>
            </div>
        </div>

        <!--Other Details-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label">Other Details</p>
            </div>
            <div class="flex-1">
                <textarea
                    placeholder="Please enter other contract details"
                    class="h-[100px] w-full resize-none border-border-basic-2 border-[1px] rounded-[8px] px-3 py-2 font-body-md-regular"
                    v-model="salaryData.otherDetails"
                    :maxlength="500">
                </textarea>
            </div>
        </div>

        <!--Effective Date*-->
        <div class="flex justify-between items-start gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center">
                <p class="c_label mandatory">Effective Date</p>
            </div>
            <div class="flex-1">
                <DesignDatepicker
                    :modelValue="toDatePickerValue(salaryData.effectiveDate)"
                    @update:output="salaryData.effectiveDate = $event"
                    format="YYYYMMDD"
                    placeholder="MM/DD/YYYY"
                    :lowerLimit="minDateForEffectiveDate"
                    class="w-96"
                />
                <p class="c_alert_message mt-1">
                    You can set the starting date from {{ minDateDisplayString }}
                    (Last Payroll Date)
                </p>
            </div>
        </div>

        <!--PIC-->
        <div class="flex justify-between items-center gap-2 mt-6">
            <div class="w-32 h-[2.75rem] flex items-center shrink-0">
                <p class="c_label mandatory">PIC</p>
            </div>
            <DesignInput
                v-model="salaryData.pic"
                :maxlength="30"
                :disabled="true"/>
        </div>
    </div>
</template>
<style scoped>
.popup_contents {
    width: calc(100% - 310px);
}

.add_popup {
    position: absolute;
    top: 0px;
}

select {
    appearance: none;
    background: url('@/assets/img/downArrow.svg') no-repeat right 16px center;
}

select option[value=''][disabled] {
    display: none;
}

input[type='date'] {
    position: relative;
    padding-right: 50px;
    background: url('@/assets/img/date_2.svg') no-repeat right 20px center;
}

input[type='date']::-webkit-clear-button,
input[type='date']::-webkit-inner-spin-button {
    display: none;
}

input[type='date']::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    color: transparent;
    cursor: pointer;
}

input[type='date'] {
    position: relative;
}

input[type='date']::before {
    content: attr(data-placeholder);
    width: 100%;
    color: #bbbbbb;
}

input[type='date']:valid::before {
    display: none;
}

/* .__datepicker::v-deep() {

    .v3dp__popout {
        bottom: 0;
        right: 0;
    }
} */

.meal_expenses {
    /* border: 1px solid black; */
    border-collapse: collapse;
}

.meal_expenses tr td {
    border-bottom: 1px solid #ebeaed;
}

.meal_expenses tr:nth-child(1) td {
    border-bottom: 1px solid #4031b8;
}

.meal_expenses tr:nth-last-child(1) td {
    border: none;
}
</style>
